module.exports = __webpack_public_path__ + "static/media/adhithyan_content.7a732542.jpg";